<template>
  <tbody>
    <tr>
      <td>
        <div class="is-flex flex-direction--column padding-left--small">
          {{ aliasId.aliasId}}
        </div>
      </td>
      <td>
        {{ aliasId.sourceCode }}
      </td>
      <td>
        {{ aliasId.name }}
      </td>
      <td>
        {{ aliasId.active === true ? 'Active' : 'Inactive' }}
      </td>
    </tr>
  </tbody>
</template>

<script>

export default {
  props: {
    aliasId: {
      type: Object,
      required: true,
    },
  },
};

</script>

<style lang="sass" scoped>
</style>
